import React from 'react';

import Error from '@/pages/_error';

const index = () => {
  return <Error status={404} />;
};

export default index;
